import { useState } from 'react';
import RebalanceTabs from './RebalanceTabs';
import { RebalancePages, RebalanceTab } from './rebalancePage/sharedTypes';
import RebalancePage from './rebalancePage/rebalancePage';
import SubtradesPage from './subtradesPage/subtradesPage';

const TABS: RebalanceTab[] = [{
  accessor: 'rebalance',
  page: RebalancePages.rebalance,
  name: RebalancePages.rebalance,
  notify: 4,
  content: <RebalancePage />,
}, {
  accessor: 'rebalance_ui',
  page: RebalancePages.rebalance_ui,
  name: RebalancePages.rebalance_ui,
  notify: 0,
  content: <div>Rebalance UI</div>,
}, {
  accessor: 'pending',
  page: RebalancePages.pending,
  name: RebalancePages.pending,
  notify: 0,
  content: <SubtradesPage state='PENDING' />,
}, {
  accessor: 'requested',
  page: RebalancePages.requested,
  name: RebalancePages.requested,
  notify: 0,
  content: <SubtradesPage state='REQUESTED' />,
}, {
  accessor: 'unsuccessful',
  page: RebalancePages.unsuccessful,
  name: RebalancePages.unsuccessful,
  notify: 0,
  content: <SubtradesPage state='UNSUCCESSFUL' />,
}, {
  accessor: 'complete',
  page: RebalancePages.complete,
  name: RebalancePages.complete,
  notify: 0,
  content: <SubtradesPage state='COMPLETE' />,
}];

const RebalanceReportV2 = () => {
  const [currentTab, setCurrentTab] = useState<RebalanceTab>(TABS[0]);

  return (
    <RebalanceTabs tabs={TABS} onChange={(_, newTab: RebalanceTab) => setCurrentTab(newTab)}>
      {currentTab.content}
    </RebalanceTabs>
  );
};

export default RebalanceReportV2;
